module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-1-preview-78faf19c2fc1b3c1ee6790e6dcd0ebdb.jpg";